const exported = {
  fillWithWhiteBackground: {
    fit: 'fill',
    bg: 'FFF',
  },

  scale: {
    fit: 'scale',
  },
};

export default exported;

export const { fillWithWhiteBackground, scale } = exported;
